import { render, staticRenderFns } from "./Loft.vue?vue&type=template&id=cb7bfdf6&scoped=true"
import script from "./Loft.vue?vue&type=script&lang=js"
export * from "./Loft.vue?vue&type=script&lang=js"
import style0 from "./Loft.vue?vue&type=style&index=0&id=cb7bfdf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7bfdf6",
  null
  
)

export default component.exports